import React from "react";
import PropTypes from "prop-types";
import Markdown from "./Markdown";

const Materials = ({ trainingComponent }) => (
  <Markdown source={trainingComponent.data.text} />
);

Materials.propTypes = {
  trainingComponent: PropTypes.object,
};

export default Materials;
